import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from "react";
import Shell from "../components/Shell";
import ExamList from "../components/ExamList";
import { useAuth } from "../lib/auth";
import { api } from "../lib/api";
export default function ParentView() {
    const { children: kids } = useAuth();
    const [activeId, setActiveId] = useState(null);
    const [rows, setRows] = useState(null);
    useEffect(() => {
        if (kids && kids.length && !activeId)
            setActiveId(kids[0].id);
    }, [kids, activeId]);
    useEffect(() => {
        if (!activeId)
            return;
        setRows(null);
        (async () => {
            const { rows } = await api.get(`/api/students/${activeId}/scores`);
            setRows(rows);
        })();
    }, [activeId]);
    if (!kids || kids.length === 0) {
        return (_jsx(Shell, { children: _jsx("p", { className: "text-slate2 text-sm", children: "Your account isn't linked to any student yet. Ask an admin to link your child's record to your login." }) }));
    }
    const current = kids.find((k) => k.id === activeId);
    return (_jsxs(Shell, { children: [_jsxs("div", { className: "mb-5 flex flex-wrap items-end gap-4 justify-between", children: [_jsxs("div", { children: [_jsx("div", { className: "eyebrow", children: "Parent view" }), _jsx("h1", { className: "font-display text-3xl mt-1", children: current?.full_name ?? "…" }), _jsx("div", { className: "text-slate2 text-sm mt-1", children: current?.class_name })] }), kids.length > 1 && (_jsx("div", { className: "flex flex-wrap gap-1.5", children: kids.map((k) => (_jsxs("button", { onClick: () => setActiveId(k.id), className: `px-3 py-1.5 rounded text-sm border transition ${k.id === activeId
                                ? "bg-accent text-paper border-accent"
                                : "bg-paper-2 text-ink border-line hover:bg-paper"}`, children: [k.full_name, " ", _jsx("span", { className: "text-xs opacity-70 ml-1", children: k.class_name })] }, k.id))) }))] }), rows === null ? _jsx("p", { className: "text-slate2 text-sm", children: "Loading\u2026" }) : _jsx(ExamList, { rows: rows })] }));
}
